import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IWorkingCopyEditorService = ( createDecorator('workingCopyEditorService'));
export { IWorkingCopyEditorService };
